import React from 'react'
import styled from 'styled-components'

const FormRowItem = styled.div`
  padding-right: 16px;
`

export default FormRowItem